module.exports = "https://cdn.hellotech.com/client-assets/members-hotline_0e6ab8b0610e2bcf84c99a68fdd097fb.svg";